import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export function AlertDialog({ open, setOpen, title, body, handleConfirm, handleCancel }) {
  const handleClose = () => {
    if (handleCancel) {
      handleCancel();
    }
    setOpen(false);
  };
  
  const taskConfirmation = () => {
    handleConfirm();
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      style={{ zIndex: 9999 }}
      disableScrollLock={false}
      keepMounted
    >
      <DialogTitle id="alert-dialog-title" style={{ fontWeight: 'bold' }}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {body}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="outlined">Não</Button>
        <Button color="error" onClick={taskConfirmation} autoFocus variant="contained">
          Sim
        </Button>
      </DialogActions>
    </Dialog>
  );
}
